export default {
  body: {
    margin: 5,
  },
  main: {
    margin: 5,
    flex: 1,
  },
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  chip: {
    margin: 10,
    // padding: 10,
  },
  profile: {
    margin: 5,
    padding: 5,
  },
  permissionHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  permissionLabel: {
    flex: 1,
  },
  tagsHeader: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
  },
  tagsLabel: {
    flex: 1,
  },
  permissionRow: {
    flexDirection: 'row',
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
  },
};



// WEBPACK FOOTER //
// ./src/components/Employee/styles.js